// extracted by mini-css-extract-plugin
export default {"textH3":"TextH3_textH3__iuwY2"};